import React from 'react';

const LeafIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747C20.446 12.438 18.067 10 15 10c-3.067 0-5.446 2.438-5.716 4.253A8.995 8.995 0 0 0 12 21Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21V10M12 21c-2.485 0-4.5-2.015-4.5-4.5S9.515 12 12 12m0 0c2.485 0 4.5 2.015 4.5 4.5S14.485 21 12 21Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3a9 9 0 0 0-9 9c0 3.067 2.438 5.446 4.253 5.716A8.995 8.995 0 0 0 12 3Z" />
  </svg>
);

export default LeafIcon;